import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { BlockQuickLinkDisplayVariant } from './model';

type ContainerProps = {
    $displayVariant: BlockQuickLinkDisplayVariant;
};

export const BlockQuickLinkCardsContainer = styled.ul<ContainerProps>`
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;

    gap: ${getPurpurSpacing('200')};
    ${purpurMedia('md')`
        gap: ${getPurpurSpacing('300')};
    `};
    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('300')};
    `};

    ${({ $displayVariant }) =>
        match($displayVariant)
            .with(
                'card-image',
                () => css`
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                    ${purpurMedia('md')`
                        grid-template-columns: repeat(3, minmax(0, 1fr));
                    `};
                    ${purpurMedia('lg')`
                        grid-template-columns: repeat(6, minmax(0, 1fr));
                    `};
                `,
            )
            .otherwise(
                () => css`
                    grid-template-columns: 1fr;
                    ${purpurMedia('md')`
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                    `};
                    ${purpurMedia('lg')`
                        grid-template-columns: repeat(4, minmax(0, 1fr));
                    `};
                `,
            )};
`;
